<template>
  <div class="TrueFalse">

    <img class="TrueFalse-image" :src="content.image" />

    <p class="TrueFalse-question"
      v-if="content.text"
      v-html="content.text">
    </p>

    <div class="TrueFalse-options">

      <button-component class="TrueFalse-option"
        v-for="option in ['True', 'False']"
        :key="option"
        @click.native="submit">
        {{ option }}
      </button-component>

    </div>

  </div>
</template>

<script>
import ButtonComponent from 'components/Button'

export default {
  name: 'TrueFalse',

  components: {
    ButtonComponent
  },

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  methods: {
    /**
     * Handle button clicks
     */
    submit () {
      this.$store.dispatch('nextLearnPage')
    }
  }
}
</script>

<style>
.TrueFalse {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 652px;
  text-align: center;
}

.TrueFalse-image {
  display: block;
  margin-top: 2rem;
  max-height: 273px;
}

.TrueFalse-question {
  width: 652px;
}

.TrueFalse-options {
  margin-top: 50px;
  max-width: 70%;
}

.TrueFalse-option {
  max-width: 50%;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// TrueFalse.vue?38385eda